module.exports = __webpack_public_path__ + "static/media/video-thumbnail-2.baddf334.png";